export const ABILITY_POINTS_DICT = {
    '1-1': '1.1 檢視文本中的資訊',
    '1-2': '1.2 擷取和使用資料',
    '2-1': "2.1 闡釋文章",
    '2-2': "2.2 整合並作出推論",
    '3-1': '3.1 評估質素和可信性',
    '3-2': "3.2 反思及評價文章的形式或內容",
    '3-3': "3.3 檢測並處理衝突",
}

export const ABILITY_POINTS_DICT_2 = {
    '1.1 檢視文本中的資訊': '1-1',
    '1.2 擷取和使用資料': '1-2',
    '2.1 闡釋文章': '2-1',
    '2.2 整合並作出推論': '2-2',
    '3.1 評估質素和可信性': '3-1',
    '3.2 反思及評價文章的形式或內容': '3-2',
    '3.3 檢測並處理衝突': '3-3',
}

export const ABILITY_POINTS_LIST = [
    '1-1',
    '1-2',
    '2-1',
    '2-2',
    '3-1',
    '3-2',
    '3-3',
]




export const PRIMARY_ABILITY_POINTS_DICT = {
    '1-1': '1.1 找出特定訊息在網頁中的具體位置',
    '1-2': '1.2 在文句中找出與特定閱讀目的有關的顯性訊息',
    '1-3': '1.3 在圖形中（如圖、表或地圖）找出特定的訊息',
    '2-1': '2.1 在多個可能的網站中確定一個最合適、適用或有用的網站,',
    '2-2': '2.2 在一個網頁中篩選出與主題相關的內容',
    '2-3': '2.3 確定一個網頁或網站中所呈現的觀點',
    '2-4': '2.4 描述文字與圖像之間的關係',
    '2-5': '2.5 推論鏈接的有用性',
    '3-2': '3.2 將一個網頁或網站的訊息/主題與另一個網頁或網站的訊息/主題進行聯繫',
    '3-3': '3.3 歸納來自相同或不同網頁或網站內的訊息/意圖',
    '3-4': '3.4 從來自多個網站的訊息得出結論',
    '4-1': '4.1 評估在網站上尋找訊息的難易程度',
    '4-2': '4.2 判定網站上訊息的可信度',
}

export const PRIMARY_ABILITY_POINTS_DICT_2 = {
    '1.1 找出特定訊息在網頁中的具體位置': '1-1',
    '1.2 在文句中找出與特定閱讀目的有關的顯性訊息': '1-2',
    '1.3 在圖形中（如圖、表或地圖）找出特定的訊息': '1-3',
    '2.1 在多個可能的網站中確定一個最合適、適用或有用的網站,': '2-1',
    '2.2 在一個網頁中篩選出與主題相關的內容': '2-2',
    '2.3 確定一個網頁或網站中所呈現的觀點': '2-3',
    '2.4 描述文字與圖像之間的關係': '2-4',
    '2.5 推論鏈接的有用性': '2-5',
    '3.2 將一個網頁或網站的訊息/主題與另一個網頁或網站的訊息/主題進行聯繫': '3-2',
    '3.3 歸納來自相同或不同網頁或網站內的訊息/意圖': '3-3',
    '3.4 從來自多個網站的訊息得出結論': '3-4',
    '4.1 評估在網站上尋找訊息的難易程度': '4-1',
    '4.2 判定網站上訊息的可信度': '4-2',
}

export const PRIMARY_ABILITY_POINTS_LIST = [
    '1-1',
    '1-2',
    '1-3',
    '2-1',
    '2-2',
    '2-3',
    '2-4',
    '2-5',
    '3-2',
    '3-3',
    '3-4',
    '4-1',
    '4-2',
]